import { Swiper, Autoplay } from 'swiper';

Swiper.use([Autoplay]);

export default (node) => {
  /**
   * Data
   */
  const intervalSpeed = node.dataset.intervalSpeed || 1500;
  const intervalSpeedMobile = node.dataset.intervalSpeedMobile || 1500;

  const initSlider = () => {
    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: intervalSpeedMobile,
        disableOnInteraction: false,
      },
      direction: 'vertical',
      breakpoints: {
        768: {
          autoplay: {
            delay: intervalSpeed,
            disableOnInteraction: false,
          },
        },
      },
    };

    const swiperObject = new Swiper(node, swiperOptions);
  };

  /**
   * Functions
   */

  /**
   * Init
   */
  const init = () => {
    initSlider();
  };

  init();
};
